// extracted by mini-css-extract-plugin
module.exports = {"main":"LorryOneLineInfo_main__kb8mO","wrapper":"LorryOneLineInfo_wrapper__I6zRk"};